<template>
  <div
    :class="['card--project', { 'card--project-connect': showCommission }]"
    v-if="project"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
  >
    <!--    <div class="card&#45;&#45;project-compare" v-show="!premier && showCompare && $mq !== 'xs'">-->
    <!--      <compare :project="project" ref="compare" />-->
    <!--    </div>-->
    <div v-show="project.subsidized" class="indicator subsidized">
      {{ $t('general.subsidized') }}
    </div>
    <div v-if="showFavorite" class="favorite" @click="toggleShortlist">
      <img
        v-if="shortlisted"
        src="@/assets/img/icons/favorite-filled.svg"
        alt="Favorite"
        class="favorite--filled"
      />
      <img v-else src="@/assets/img/icons/favorite-white.svg" alt="Favorite Outline" />
    </div>
    <div class="top--part">
      <card-project-image
        :linkDetail="detailUrl"
        :photos="project.photos"
        :primaryPhoto="project.primary_photo"
        :allowMultiImage="allowMultiImage"
        :imageAlt="project.title"
        :useExternalLink="useExternalLink"
      ></card-project-image>
      <div v-if="showCommission && project.property_type" class="project-type-badge">
        <v-icon small>mdi-home-city-outline</v-icon>
        <span>{{ project.property_type }}</span>
      </div>
    </div>
    <a :href="detailUrl" target="_blank" style="text-decoration: none" v-if="useExternalLink">
      <div class="bottom--part">
        <h3 class="name multiline-ellipsis-2">
          {{ project.title }}
        </h3>
        <div class="location mb-1" v-if="showCommission && (project.district || project.city)">
          <img src="@/assets/img/icons/pin-1.svg" alt="Location Pin" />
          <div v-clampy="2">
            <span>{{ project.district }}</span>
            <span v-if="project.district && project.city">, </span>
            <span>{{ project.city }}</span>
          </div>
        </div>
        <div class="label--container">
          <div class="label" v-if="project.property_type && !showCommission">
            {{ project.property_type }}
          </div>
          <div class="d-flex">
            <div class="label--room mr-2">
              <v-icon class="mr-1">mdi-bed</v-icon
              >{{ compareMinMax(project.min_bedroom, project.max_bedroom) }}
            </div>
            <div class="label--room">
              <v-icon class="mr-1">mdi-shower-head</v-icon
              >{{ compareMinMax(project.min_bathroom, project.max_bathroom) }}
            </div>
          </div>
        </div>
        <div class="location mb-1" v-if="!showCommission && (project.district || project.city)">
          <img src="@/assets/img/icons/pin-1.svg" alt="Location Pin" />
          <div v-clampy="2">
            <span>{{ project.district }}</span>
            <span v-if="project.district && project.city">, </span>
            <span>{{ project.city }}</span>
          </div>
        </div>
        <div :class="['price--after', { 'price--after-project-connect': showCommission }]">
          <div class="price--copy">
            <span>{{ $t('general.priceStartFrom') }} </span>
            <span>{{ project.min_price_str }}</span>
          </div>
          <img
            v-if="showCommission && project.developer_photo"
            :src="project.developer_photo"
            alt="Developer Logo"
            class="developer--logo"
          />
        </div>
        <div class="commission--section" v-if="hasCommission">
          <span>Komisi</span>
          <strong>{{ formattedCommission }}</strong>
        </div>
        <div class="commission--disclaimer" v-if="showCommission && project.commission_disclaimer">
          {{ project.commission_disclaimer }}
        </div>
        <div class="available" v-if="!showCommission">
          <span>{{ $t('general.available') }} </span>
          <span>{{ project.total_available_units }} </span>
          <span>{{ $t('general.unit') }} </span>
        </div>
      </div>
    </a>
    <router-link
      :to="project.links ? project.links.detail : '/'"
      style="text-decoration: none"
      v-else
    >
      <div class="bottom--part">
        <h3 class="name multiline-ellipsis-2">
          {{ project.title }}
        </h3>
        <div class="location mb-1" v-if="showCommission && (project.district || project.city)">
          <img src="@/assets/img/icons/pin-1.svg" alt="Location Pin" />
          <div v-clampy="2">
            <span>{{ project.district }}</span>
            <span v-if="project.district && project.city">, </span>
            <span>{{ project.city }}</span>
          </div>
        </div>
        <div class="label--container">
          <div class="label" v-if="project.property_type && !showCommission">
            {{ project.property_type }}
          </div>
          <div class="d-flex">
            <div class="label--room mr-2">
              <v-icon class="mr-1">mdi-bed</v-icon
              >{{ compareMinMax(project.min_bedroom, project.max_bedroom) }}
            </div>
            <div class="label--room">
              <v-icon class="mr-1">mdi-shower-head</v-icon
              >{{ compareMinMax(project.min_bathroom, project.max_bathroom) }}
            </div>
          </div>
        </div>
        <div class="location mb-1" v-if="!showCommission && (project.district || project.city)">
          <img src="@/assets/img/icons/pin-1.svg" alt="Location Pin" />
          <div v-clampy="2">
            <span>{{ project.district }}</span>
            <span v-if="project.district && project.city">, </span>
            <span>{{ project.city }}</span>
          </div>
        </div>
        <div :class="['price--after', { 'price--after-project-connect': showCommission }]">
          <div class="price--copy">
            <span>{{ $t('general.priceStartFrom') }} </span>
            <span>{{ project.min_price_str }}</span>
          </div>
          <img
            v-if="showCommission && project.developer_photo"
            :src="project.developer_photo"
            alt="Developer Logo"
            class="developer--logo"
          />
        </div>
        <div class="commission--section" v-if="hasCommission">
          <span>Komisi</span>
          <strong>{{ formattedCommission }}</strong>
        </div>
        <div class="commission--disclaimer" v-if="showCommission && project.commission_disclaimer">
          {{ project.commission_disclaimer }}
        </div>
        <div class="available" v-if="!showCommission">
          <span>{{ $t('general.available') }} </span>
          <span>{{ project.total_available_units }} </span>
          <span>{{ $t('general.unit') }} </span>
        </div>
      </div>
    </router-link>
    <div class="bottom--part">
      <slot name="after-commission"></slot>
    </div>
  </div>
</template>

<script>
import CardProjectImage from '@/components/utils/partials/card-project-image';
// const Compare = () => import('@/components/utils/partials/compare');
import HelperMixin from '@/mixins/helpers';
import { mapState } from 'vuex';

export default {
  mixins: [HelperMixin],
  components: {
    CardProjectImage,
    // Compare,
  },
  props: {
    project: {
      default: null,
      require: true,
    },
    premier: {
      default: false,
    },
    showCompare: {
      default: true,
    },
    allowMultiImage: {
      default: false,
    },
    showFavorite: {
      default: true,
    },
    showCommission: {
      default: false,
    },
    commission: {
      default: null,
    },
    useExternalLink: {
      default: false,
    },
  },
  data: () => ({
    debounceCompare: null,
  }),
  computed: {
    ...mapState({
      shortlists: (state) => state.v2.search.shortlists,
      isLoggedIn: (state) => state.global.loggedIn,
    }),
    shortlisted() {
      if (this.shortlists && this.shortlists.length === 0) {
        return false;
      } else {
        return this.shortlists.indexOf(this.project.uuid) !== -1;
      }
    },
    detailUrl() {
      const link = this.project.links ? this.project.links.detail : '/';
      if (this.useExternalLink) {
        return process.env.VUE_APP_USER_URL + link;
      }
      return link;
    },
    hasCommission() {
      return this.commission !== null && this.commission !== undefined && this.commission !== '';
    },
    formattedCommission() {
      if (!this.hasCommission) {
        return '-';
      }
      const commission = Number(this.commission);
      if (Number.isNaN(commission)) return '-';
      return `${
        Number.isInteger(commission) ? commission : commission.toFixed(2).replace(/\.?0+$/, '')
      }%`;
    },
  },
  methods: {
    async toggleShortlist() {
      if (this.isLoggedIn) {
        let response = await this.$store.dispatch('v2/project/addOrRemoveShortlist', {
          projectUuid: this.project.uuid,
        });
        await this.$store.commit('v2/search/set_shortlists', response);
      } else {
        this.$modal.show('modal-login');
      }
    },
    onMouseDown() {
      // Hold down to add project to compare still not working
      // if (this.$mq === 'xs') {
      //   this.debounceCompare = this.debounce(this.addToCompare, 50);
      // }
    },
    onMouseUp() {
      // Hold down to add project to compare still not working
      // if (this.$mq === 'xs') {
      //   this.debounceCompare = null;
      // }
    },
    addToCompare(project) {
      this.$store.commit('v2/project/set_compare_project', project);
      this.$store.commit('v2/project/set_compare_show', true);
    },
  },
  filters: {
    lowerCase(e) {
      return e.toLowerCase();
    },
  },
};
</script>
